import React, { useState } from "react";
import {
  Container,
  Typography,
  Box,
  Grid,
  Card,
  CardContent,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";

const jobListings = [
  {
    title: "ServiceNow Developer",
    location: " Pune, Bengaluru, Hyderabad",
    Experience: "3+ years",
    Skills: "ITSM, CSM, JavaScript, API Integrations",
  },
  {
    title: "ServiceNow Sr. Developer",
    location: "Pune, Bengaluru, Hyderabad",
    Experience: "5+ years",
    Skills: "TSM, ITOM, CSM, Portal, API Integrations",
  },
  {
    title: "ServiceNow Lead",
    location: "Remote",
    Experience: "7+ years",
    Skills: "ITSM, ITOM, CSM, Portal, Catalog, HRSD, GRC, API Integrations",
  },
  {
    title: "Java Developer",
    location: "PAN India",
    Experience: "3+ years",
    Skills: "Java 8, Spring boot, API Integrations",
  },
  {
    title: "Java Architect",
    location: "PAN India",
    Experience: "7+ years",
    Skills: "Java 8, Springboot, Microservices, Multithreading, DB Transactions",
  },
  {
    title: ".Net Developer",
    location: "Pune, Bengaluru, Hyderabad",
    Experience: "3+ years",
    Skills: "NET Core, RESTful API, Microservices, SQL",
  },
  {
    title: "Python Developer",
    location: "Pune, Bengaluru, Hyderabad",
    Experience: "3+ years",
    Skills: "Python programming, PySpark, DevOps, CICD",
  },
  {
    title: "Automation Engineer",
    location: "Pune, Bengaluru, Hyderabad",
    Experience: "5+ years",
    Skills: "Test Automation using Python scripting, pytest, unittest",
  },
  {
    title: "Oracle DBA",
    location: "Pune, Bengaluru, Hyderabad",
    Experience: "8+ years",
    Skills: "DBA with experience in Automation and Scripting",
  },
];

const Careers = () => {
  const [open, setOpen] = useState(false);
  const [selectedJob, setSelectedJob] = useState(null);
  const [submitted, setSubmitted] = useState(false);

  const handleJobOpen = (job) => {
    setSelectedJob(job);
    setSubmitted(false);
    setOpen(true);
  };

  const handleContactHROpen = () => {
    setSelectedJob(null);
    setSubmitted(true);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedJob(null);
    setSubmitted(false);
  };

  const handleSubmit = () => {
    setSubmitted(true);
    window.location.href = `mailto:hr@nexexcellency.com?subject=Application for ${selectedJob?.title || "Open Position"}`;
  };

  return (
    <Box sx={{minHeight: "100vh", py: 5 }}>
      <Container maxWidth="lg">
        <Box sx={{ mb: 6, textAlign: "center" }}>
          <Typography variant="h3" gutterBottom>
            Join Our Team
          </Typography>
          <Typography variant="h6" color="gray">
            We're building the future — and we want you on board.
          </Typography>
        </Box>

        <Box sx={{ mb: 6 }}>
          <Typography variant="h4" gutterBottom>
            Open Positions
          </Typography>
          <Grid container spacing={4}>
            {jobListings.map((job, index) => (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <Card
                  sx={{
                    height: "100%",
                    backgroundColor: "rgba(52, 39, 153, 0.13)",
                    color: "#fff",
                    display: "flex",
                    padding: 1,
                    flexDirection: "column",
                    justifyContent: "space-between",
                    gap: 2,
                    transition: "box-shadow 0.3s ease-in-out",
                    "&:hover": {
                      boxShadow: "0 0 15px 5px rgba(20, 28, 146, 0.6)",
                    },
                  }}
                >
                  <CardContent sx={{ textAlign: "center" }}>
                    <Typography variant="h6" fontWeight="bold" gutterBottom>
                      {job.title}
                    </Typography>

                    <Box sx={{ mb: 1 }}>
                      <Typography
                        component="span"
                        sx={{ fontWeight: "bold", color: "#00BFFF" }}
                      >
                        Skills:{" "}
                      </Typography>
                      <Typography
                        component="span"
                        sx={{
                          fontStyle: "italic",
                          fontWeight: 500,
                          color: "#e0e0e0",
                        }}
                      >
                        {job.Skills}
                      </Typography>
                    </Box>

                    <Box sx={{ mb: 1 }}>
                      <Typography
                        component="span"
                        sx={{ fontWeight: "bold", color: "#00BFFF" }}
                      >
                        Experience:{" "}
                      </Typography>
                      <Typography
                        component="span"
                        sx={{
                          fontStyle: "italic",
                          fontWeight: 500,
                          color: "#e0e0e0",
                        }}
                      >
                        {job.Experience}
                      </Typography>
                    </Box>

                    <Box>
                      <Typography
                        component="span"
                        sx={{ fontWeight: "bold", color: "#00BFFF" }}
                      >
                        Location:{" "}
                      </Typography>
                      <Typography
                        component="span"
                        sx={{
                          fontStyle: "italic",
                          fontWeight: 500,
                          color: "#e0e0e0",
                        }}
                      >
                        {job.location}
                      </Typography>
                    </Box>
                  </CardContent>

                  <Box sx={{ px: 2, pb: 2, textAlign: "center" }}>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => handleJobOpen(job)}
                    >
                      Apply Now
                    </Button>
                  </Box>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>

        {/* Contact HR CTA */}
        <Box
          sx={{
            textAlign: "center",
            mt: 8,
            p: 4,
            backgroundColor: "#1f1f1f",
            borderRadius: 2,
          }}
        >
          <Typography variant="h5" gutterBottom>
            Don't see a role that fits?
          </Typography>
          <Typography variant="body1" gutterBottom>
            We're always looking for talented people. Reach out anyway!
          </Typography>
          <Button variant="outlined" color="primary" onClick={handleContactHROpen}>
            Contact HR
          </Button>
        </Box>

        {/* Dialog */}
        <Dialog open={open} onClose={handleClose}>
          <DialogTitle>
            {submitted
              ? "Thank you for your interest!"
              : `Apply for ${selectedJob?.title}`}
          </DialogTitle>

          <DialogContent
            sx={{
              minHeight: 150,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: submitted ? "#e8f5e9" : "inherit",
              textAlign: "center",
            }}
          >
            {submitted ? (
              <Typography variant="body1">
                Please send your resume to{" "}
                <a
                  href="mailto:hr@nexexcellency.com"
                  style={{
                    color: "#2e7d32",
                    fontWeight: "bold",
                    textDecoration: "underline",
                  }}
                >
                  hr@nexexcellency.com
                </a>
              </Typography>
            ) : (
              <>
                <Typography
                  variant="subtitle1"
                  sx={{ fontWeight: "bold", color: "primary.main", mb: 1 }}
                >
                  Location: {selectedJob?.location}
                </Typography>
                <Typography
                  variant="subtitle1"
                  sx={{ fontWeight: "bold", color: "primary.main" }}
                >
                  Experience: {selectedJob?.Experience}
                </Typography>
                <Typography sx={{ mt: 2 }}>{selectedJob?.Skills}</Typography>
              </>
            )}
          </DialogContent>

          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Close
            </Button>
            {!submitted && (
              <Button variant="contained" color="primary" onClick={handleSubmit}>
                Submit Application
              </Button>
            )}
          </DialogActions>
        </Dialog>
      </Container>
    </Box>
  );
};

export default Careers;
